var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlob5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 559,
    height: 559,
    viewBox: "0 0 559 468",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M241.5 64.9995C299.248 61.9053 365.5 -3.99966 439.5 1.00008C510.5 12.2504 515.968 40.6425 540 90C563.849 138.982 572 200.5 523 217.5C473 251.501 485.39 349.101 480 413.834C480 452.101 439.695 467.5 372.5 467.5C319.5 460.5 249.176 449.187 192 438.5C134.739 427.797 58.8721 461.741 32.942 413.834C9.85053 371.172 24 324 32.942 275C32.942 222 32.9421 236 14.5001 185C-1.91098 139.617 -5.98386 112.64 14.5001 78.5003C40 36.0003 187.497 67.8931 241.5 64.9995Z",
    fill: "#F3E8E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlob5);
export default __webpack_public_path__ + "static/media/Blob5.5d7f66679f60d495f4bf7c2ac177883a.svg";
export { ForwardRef as ReactComponent };